import React, { ReactNode } from 'react'
import { ScrollView } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { NavigationContainer } from '@screens/Common/containers'
import { StyleService, useStyleSheet } from '@style/service.ts'

export const ProgramDetailsHeader = ({ children }: { children: ReactNode }) => {
  const styles = useStyleSheet(themedStyle)
  const insets = useSafeAreaInsets()

  return (
    <NavigationContainer title="Manage Subscription">
      <ScrollView
        style={styles.container}
        contentContainerStyle={{ flexGrow: 1, paddingBottom: insets.bottom + 16 }}
      >
        {children}
      </ScrollView>
    </NavigationContainer>
  )
}

const themedStyle = StyleService.create({
  container: {
    backgroundColor: 'theme.background',
  },
})
